import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';
import BigCalendar from 'react-big-calendar';
import dates from 'react-big-calendar/lib/utils/dates';
import { Element } from 'react-scroll';
import {
  compact,
  get,
  groupBy,
  orderBy,
} from 'lodash';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Refresh from '@material-ui/icons/Refresh';

import {
  Avatar,
  HeaderTitle,
  Helper,
  injectIntl,
  Paper,
  PrintPreviewDialog,
  ScrollToTop,
  SyncComponent,
} from 'components';
import immutableToJS from 'helpers/immutableToJS';
import {
  dispatchRestMaker,
  getFullNameOrEmail,
  includesSearchText,
  scrollTo,
  toISO,
  formatPrice,
} from 'helpers/utils';
import { isMobile } from 'helpers/detect-mobile';
import ordersActions, { getPickList, getPackList, getWarehouseList, getDailySalesPurchases } from 'redux/orders/actions';
import { selectState } from 'redux/selectors';

import CalendarToolbar from './components/CalendarToolbar';
import DropDownPrint from './components/DropDownPrint';
import InvoiceCard from './components/InvoiceCard';
import InvoiceListToolbar from './components/InvoiceListToolbar';
import MonthlyInvoices from './components/MonthlyInvoices';
import { FILTER } from './constants';
import PackListPrint from './components/PackListPrint';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k]);
const localizer = BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
import qs from 'query-string';
import { Container, Col, Row } from 'reactstrap';

const styles = () => ({
  filterButton: {
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    marginRight: 10,
    marginBottom: 5,
  },
  filterButtonLabel: {
    color: '#4694EB',
    fontSize: 12,
    whiteSpace: 'nowrap',
  },
  dropdown: { width: 160 },
  selectIcon: { top: 4 },
  selectInput: {
    border: 'none',
    paddingLeft: 10,
  },
  selectLabel: { top: -5 },
  selectRoot: {
    backgroundColor: '#fff',
    border: '2px solid #3fa8d7',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
  toggleLabel: { width: 70 },
});

class Calendar extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isDistributor: PropTypes.bool,
    isFarmer: PropTypes.bool,
    isRestaurant: PropTypes.bool,
    isConsumer: PropTypes.bool,
    noAutoPay: PropTypes.bool,
  };

  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    orderRequesting: PropTypes.bool.isRequired,
    orders: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    ordersRequesting: PropTypes.bool,
    packList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    packListRequesting: PropTypes.bool,
    pickList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),
    pickListRequesting: PropTypes.bool,
    warehouseList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ),

    formatMessage: PropTypes.func.isRequired,
    getPackList: PropTypes.func.isRequired,
    getPickList: PropTypes.func.isRequired,
    getWarehouseList: PropTypes.func.isRequired,
    listOrders: PropTypes.func.isRequired,
    readOrder: PropTypes.func.isRequired,
    updateOrder: PropTypes.func.isRequired,
    dailySalesPurchases: PropTypes.shape({}),
    getDailySalesPurchases: PropTypes.func.isRequired,
  };

  static defaultProps = {
    ordersRequesting: false,
    packList: [],
    packListRequesting: false,
    pickList: [],
    pickListRequesting: false,
    warehouseList: [],
    dailySalesPurchases: {},
  };

  state = {
    deliveryDate: toISO(moment()),
    endDate: '',
    expanded: -1,
    filter: '',
    isPack: false,
    isPick: false,
    isWarehouse: false,
    printDlgOpen: false,
    printDlgTitle: '',
    printRequesting: '',
    requestingId: null,
    searchText: '',
    sortDirection: true,
    sortMethod: 'companyName',
    startDate: '',
    orderRequesting: true,
    salesInvoices:[],
    printHeaderChecked: [],
    currentSize:'normal',
    isTrack: false,
    placedOrderDialogOpen: false,
  };

  componentWillMount() {
    this.onNavigate(moment());
    const { isDistributor } = this.context;
    const { getDailySalesPurchases } = this.props;
    const { printHeaderChecked, deliveryDate } = this.state;
    printHeaderChecked.push(true, true, true, true, true, true, true, true, true, true, true);
    if (isDistributor) {
      getDailySalesPurchases(deliveryDate);
    }
  }

  updateCheckState = (isChecked, index) => {
    const { printHeaderChecked } = this.state;
    printHeaderChecked[index] = isChecked;
    this.setState({ printHeaderChecked: printHeaderChecked.slice() });
  }

  onCancelSearch = () => this.setState({ searchText: '' });

  getSalesList = () => {
    const { readOrder } = this.props;
    const currentOrders = this.getOrders();
    
    currentOrders.map((order) => { 
      readOrder(order.id);
    });
  } 

  onFilterChange = (value, isPack = false) => {
    const { formatMessage, getPackList } = this.props;
    const { deliveryDate } = this.state;
    switch (value) {
      case FILTER.SALES_INVOICES: {
        this.getSalesList();
        this.setState({
          filter: value,
          printDlgTitle: formatMessage('Sales Invoices'),
          printRequesting: 'packList',
        });
        break;
      }
      case FILTER.LABELS: {
        const isTrack = true;
        getPackList({ deliveryDate: moment(deliveryDate).format('YYYY-MM-DD'), isTrack });
        this.setState({
          filter: value,
          printDlgTitle: formatMessage('Labels'),
          printRequesting: 'printLabelData',
          currentSize: 'normal',
        });
        break;
      }
      case FILTER.PICK_PACK: {
        this.setState({
          filter: value,
          printDlgTitle: isPack ? formatMessage('Pack List') : formatMessage('Pick List'),
          isPack,
          isPick: !isPack,
          isWarehouse: false,
          printRequesting: 'packList',
        });
        break;
      }
      case FILTER.WAREHOUSE: {        
        this.setState({
          filter: value,
          printDlgTitle: formatMessage('Warehouse List'),
          isPick: false,
          isWarehouse: true,
          printRequesting: 'warehouseList',
        });
        break;
      }
      case FILTER.GROUPED_LIST: {
        this.setState({
          filter: value,
          printDlgTitle: formatMessage('Grouped List'),
          isPick: false,
          isWarehouse: false,
          printRequesting: 'packList',
        });
        break;
      }
      case FILTER.HARVEST: {
        this.setState({
          filter: value,
          printDlgTitle: formatMessage('Harvest List'),
          isPick: false,
          isWarehouse: false,
          printRequesting: 'packList',
        });
        break;
      }
      default:
        break;
    }
    this.onPrintOpen();
  }

  onNavigate = (date) => {
    const { isConsumer } = this.context;
    const { location: { state }} = this.props;
    const queryParams = qs.parse(this.props.location.search);
    const expanded = state && state.orderId ? state.orderId : (queryParams && queryParams.order_id ? queryParams.order_id : this.props.expanded);
    const deliveryDate = state && state.deliveryDate ? state.deliveryDate : (queryParams && queryParams.delivery_date ? queryParams.delivery_date : null);
    this.props.history.replace({ ...this.props.history.location, state: {} });
    const startDate = !deliveryDate ? dates.firstVisibleDay(date) : dates.firstVisibleDay(deliveryDate);
    const endDate = !deliveryDate ? dates.lastVisibleDay(date) : dates.lastVisibleDay(deliveryDate);
    // startDate.setMonth(startDate.getMonth() - 1);
    endDate.setDate(endDate.getDate() + 1);
    if (expanded && isConsumer && state && state.orderId) {
      this.setState({ placedOrderDialogOpen: true });
    }
    this.setState(
      {
        deliveryDate: deliveryDate ? toISO(deliveryDate) : toISO(moment()),
        endDate,
        filter: '',
        startDate,
        expanded: Number(expanded),
        isTrack: true,
      },
      this.onRefreshCalendar,
    );
  }

  onGetOrderMessage = (channel, order) => {
    const { expanded } = this.state;
    if (order === 'updated') {
      this.setState({
        orderRequesting: false,
      });
      this.props.readOrder(
        channel,
        {
          noDetail: Number(expanded) !== Number(channel),
          onSuccess: () => {
            this.setState({ orderRequesting: true });
          },
        },
      );
    }
    // console.log(channel, order, 'onGetOrderMessage');
  }

  onOrderUpdated = (orderId) => {
    this.sendMessage(orderId, 'updated');
  };

  onPrintClose = () => {
    this.setState({
      printDlgOpen: false,
      printRequesting: '',
    });
  }
  onPrintOpen = () => this.setState({ printDlgOpen: true });

  onRefreshCalendar = () => {
    const { listOrders } = this.props;
    const { startDate, endDate, isTrack } = this.state; // TODO should put on Calendar
    listOrders({
      startDate,
      endDate,
      isTrack,
    });
  }

  onSearchText = value => this.setState({ searchText: value });

  onSelectSlot = ({ start }) => {
    const { isDistributor } = this.context;
    const { getPickList, getDailySalesPurchases } = this.props;
    this.setState({
      deliveryDate: toISO(start),
      expanded: -1,
      searchText: '',
      sortDirection: true,
      sortMethod: 'companyName',
    });
    if (isDistributor) {
      getDailySalesPurchases(moment(start).format('YYYY-MM-DD'));
    }
    getPickList({ deliveryDate: moment(start).format('YYYY-MM-DD') });
    this.getWarehouseListData();
    this.scroll = true;
    this.scrollToInvoiceList();
  }

  onSortByCustomer = () => {
    const sortMethod = 'companyName';
    const { sortDirection } = this.state;
    const currentState = this.state.sortMethod;

    if (sortMethod === currentState) {
      this.setState({ sortDirection: !sortDirection });
    } else {
      this.setState({ sortMethod });
      this.setState({ sortDirection: false });
    }
  }

  onSortByOrder = () => {
    const sortMethod = 'createdAt';
    const { sortDirection } = this.state;
    const currentState = this.state.sortMethod;

    if (sortMethod === currentState) {
      this.setState({ sortDirection: !sortDirection });
    } else {
      this.setState({ sortMethod });
      this.setState({ sortDirection: false });
    }
  }

  getEvents = () => {
    const { orders } = this.props;
    const { isFarmer, isRestaurant, isDistributor } = this.context;
    const events = [];
    const ordersList = groupBy(orders, 'deliveryDate');
    const dates = Object.keys(ordersList);
    dates.forEach((date) => {
      const ordersByDate = ordersList[date];
      const salesCount = ordersByDate.filter(({ type, createdAsDraft, isConsumer }) => !createdAsDraft && type === 'SO' && !isConsumer).length;
      const salesInvalid = !!ordersByDate.find(({ createdAsDraft, invalid, type, isConsumer }) => !createdAsDraft && invalid && type === 'SO' && !isConsumer);
      const consumerSalesCount = ordersByDate.filter(({ type, isConsumer }) => isConsumer && type === 'SO').length;
      const consumerSalesInvalid = !!ordersByDate.find(({ isConsumer, invalid, type }) => isConsumer && invalid && type === 'SO');
      const purchasesCount = ordersByDate.filter(({ createdAsDraft, type }) => !createdAsDraft && type === 'PO').length;
      const purchasesInvalid = !!ordersByDate.find(({ invalid, type }) => invalid && type === 'PO');
      const aggregatedCount = ordersByDate.filter(({ createdAsDraft }) => createdAsDraft).length;
      const draftCount = ordersByDate.filter(({ isDraft }) => isDraft).length;
      const aggregatedInvalid = !!ordersByDate.filter(({ createdAsDraft, invalid }) =>
        invalid && createdAsDraft);
      const additionalHour = moment(date).add(1, 'hour');
      if (!isRestaurant && salesCount > 0) {
        events.push({
          end: additionalHour,
          start: moment(date),
          title: salesCount,
          type: salesInvalid ? 'primary-danger' : 'primary',
        });
      }
      if (!isRestaurant && consumerSalesCount > 0) {
        events.push({
          end: additionalHour,
          start: moment(date),
          title: consumerSalesCount,
          type: consumerSalesInvalid ? 'orange-danger' : 'orange',
        });
      }
      if (!isFarmer && purchasesCount > 0) {
        events.push({
          end: additionalHour,
          start: additionalHour,
          title: purchasesCount,
          type: purchasesInvalid ? 'warning-danger' : isDistributor ? 'green' : 'warning',
        });
      }
      if (aggregatedCount > 0) {
        if (draftCount <= 0) {
          events.push({
            end: additionalHour,
            start: additionalHour,
            title: aggregatedCount,
            type: aggregatedInvalid ? (isDistributor ? 'warning' : 'green-danger') : 'green',
          });
        } else {
          events.push({
            end: additionalHour,
            start: additionalHour,
            title: isFarmer ? 'Harvest list' : aggregatedCount,
            type: aggregatedInvalid ? (isDistributor ? 'warning' : 'green-danger') : 'green',
            category: isFarmer ? 'draft' : '',
          });
        }
      }
    });

    return events;
  }

  getExpandedOrder = () => {
    const { expanded } = this.state;
    const { orders } = this.props;
    const {
      deliveryDate,
      searchText,
      sortDirection,
      sortMethod,
    } = this.state;
    if (!expanded) {
      return {};
    }
    let customSortMethod = sortMethod;
    if (sortMethod === 'companyName') {
      customSortMethod = r => (r.type === 'PO'
        ? r.seller.account.profile[sortMethod] : r.buyer.account.profile[sortMethod]);
    }
    const sortedOrders = orderBy(orders,
      ['type', customSortMethod, 'createdAt'],
      ['desc', `${sortDirection === true ? 'asc' : 'desc'}`, 'desc']);
    const filteredOrders = sortedOrders.filter(order => includesSearchText(
      searchText,
      [
        `${order.id}`,
        `${order.orderNum}`,
        order.type === 'PO' ? order.seller.account.profile.companyName : order.buyer.account.profile.companyName,
        order.type === 'PO' ? order.seller.account.email : order.buyer.account.email,
        order.type,
        order.updatedAt,
      ],
    ));

    const expandedOrder = filteredOrders.filter(order => order.deliveryDate === deliveryDate && order.id === expanded);
    const expandedOrderDetail = expandedOrder && expandedOrder.length > 0 ? expandedOrder[0] : {};
    return expandedOrderDetail;
  }

  getOrders = () => {
    const { orders } = this.props;
    const {
      deliveryDate,
      searchText,
      sortDirection,
      sortMethod,
    } = this.state;
    let customSortMethod = sortMethod;
    if (sortMethod === 'companyName') {
      customSortMethod = r => (r.type === 'PO'
        ? r.seller.account.profile[sortMethod] : r.buyer.account.profile[sortMethod]);
    }
    const sortedOrders = orderBy(orders,
      ['type', customSortMethod, 'createdAt'],
      ['desc', `${sortDirection === true ? 'asc' : 'desc'}`, 'desc']);
    const filteredOrders = sortedOrders.filter(order => includesSearchText(
      searchText,
      [
        `${order.id}`,
        `${order.orderNum}`,
        order.type === 'PO' ? order.seller.account.profile.companyName : order.buyer.account.profile.companyName,
        order.type === 'PO' ? order.seller.account.email : order.buyer.account.email,
        order.type,
        order.updatedAt,
      ],
    ));
    if (searchText !== '') {
      return filteredOrders;
    }
    return filteredOrders.filter(order => order.deliveryDate === deliveryDate);
  }

  getPackListData = () => {
    const { getPackList } = this.props;
    const { deliveryDate } = this.state;

    getPackList({ deliveryDate: moment(deliveryDate).format('YYYY-MM-DD') });
  }

  getPickListData = () => {
    const { getPickList } = this.props;
    const { deliveryDate } = this.state;

    getPickList({ deliveryDate: moment(deliveryDate).format('YYYY-MM-DD') });
  }

  getWarehouseListData = () => {
    const { getWarehouseList } = this.props;
    const { deliveryDate } = this.state;
    getWarehouseList({ deliveryDate: moment(deliveryDate).format('YYYY-MM-DD') });
  }

  eventStyleGetter = (event) => {
    const backgroundColor = {
      primary: '#1976d2',
      'primary-danger': '#1976d2',
      orange: '#ff602e',
      'orange-danger': '#ff602e',
      secondary: '#9fa1a3',
      warning: '#ff9800',
      'warning-danger': '#ff9800',
      green: '#6eb761',
      'green-danger': '#6eb761',
      'warning': '#ff9801'
    }[event.type];
    const fontWeight = {
      'primary-danger': 'bold',
      'warning-danger': 'bold',
      'green-danger': 'bold',
      'warning': 'bold',
    }[event.type] || 'regular';
    const style = {
      background: backgroundColor,
      fontWeight,
    };

    const className = event.category ? 'category-' + event.category.toLowerCase() : '';

    return {
      style,
      className,
    };
  }

  scrollToInvoiceList = () => {
    scrollTo('dateWrapper');
  }

  handlePrintSizeChange = (size) => {
    this.setState({ currentSize: size });
  }

  handlePlacedOrderDialogClose = () => {
    this.setState({ placedOrderDialogOpen: false });
  }

  render() {
    const {
      currentUser,
      isDistributor,
      isFarmer,
      isRestaurant,
    } = this.context;
    const {
      classes,
      formatMessage,
      orderRequesting,
      ordersRequesting,
      packList,
      packListRequesting,
      pickList,
      pickListRequesting,
      warehouseList,
      readOrder,
      updateOrder,
      dailySalesPurchases,
    } = this.props;
    const {
      deliveryDate,
      expanded,
      filter,
      isPack,
      isPick,
      isWarehouse,
      printDlgOpen,
      printDlgTitle,
      printRequesting,
      requestingId,
      searchText,
      sortDirection,
      sortMethod,
      salesInvoices,
      printHeaderChecked,
      currentSize,
      placedOrderDialogOpen,
    } = this.state;

    const currentDate = moment(deliveryDate).format('MMM DD, ddd');
    const formats = {
      monthHeaderFormat: (deliveryDate, culture, localizer) => localizer.format(deliveryDate, 'MMM YYYY'),
    };
    const expandedOrder = this.getExpandedOrder();
    const currentOrders = this.getOrders();
    const events = this.getEvents();
    let filterData = [];
    if (isWarehouse) {
      filterData = warehouseList;
    } else if (isPick) {
      filterData = pickList;
    } else {
      filterData = packList;
    }
    filterData = orderBy(
      filterData,
      compact([
        filter === FILTER.PICK_PACK && (item => get(item, 'order.buyer.account.companyName') || ''),
        item => `${get(item, 'data.productData.name')} ${get(item, 'data.productData.subname')}`,
      ]),
      compact([
        filter === FILTER.PICK_PACK && 'asc',
        'asc',
      ]),
    );

    const queryParams = qs.parse(this.props.location.search);
    const queryDeliveryDate = queryParams && queryParams.delivery_date;

    return (
      <div className="calendar-page">
        <HeaderTitle>
          {formatMessage('Track Orders')}
        </HeaderTitle>
        <Helper name="calendar" />
        <div className="calendar-top">
          <div className="calendar-tool-wrapper">
            <div className="d-md-down-none"> 
              <div className="avatar-wrapper">
                <div className="user-info">
                  <Avatar
                    fullName={getFullNameOrEmail(currentUser.account)}
                    src={get(currentUser, 'account.profile.logoUrl')}
                  />
                  <div className="avatar-info">
                    <div>{currentUser.account.profile.companyName}</div>
                    <div>{currentUser.account.email}</div>
                  </div>
                </div>
                <div className="monthly-invoices-wrapper">
                  { (currentUser.roleId != 5) &&
                      <MonthlyInvoices />
                  }
                  <MonthlyInvoices isPurchase />
                </div>
              </div>
              <Element className="date-wrapper" name="dateWrapper" style={{ marginBottom: '0' }}>
                <div className="current-date">{currentDate}</div>
              </Element>
              { isDistributor && currentOrders && currentOrders.length ? (
                <Element className="business-information-wrapper" name="dateWrapper">
                    <span>{formatMessage('Sales:')}{` $${formatPrice(dailySalesPurchases.sales)}`}</span>
                    <span>{formatMessage('Cost:')}{` $${formatPrice(dailySalesPurchases.purchases)}`}</span>
                    <span>{formatMessage('Net:')}{` $${formatPrice(dailySalesPurchases.profit)} (${formatPrice(dailySalesPurchases.profitPercent)}%)`}</span>
                </Element>
              ) : (<span></span>)}
            </div>
            <div className="d-lg-up-none">
              <div className="filter-title-wrapper">
                <div className="calendar-title">{formatMessage('Deliveries / Pick-ups')}</div>
                <div className="d-flex">
                  {isFarmer ? (<MonthlyInvoices />) : (<MonthlyInvoices isPurchase />)}
                </div>
              </div>
              <div className="filter-date-wrapper">
                <div className="current-date">{currentDate}</div>
                <div className="d-flex" style={{alignItems:'center'}}>
                  {isDistributor && (<MonthlyInvoices />)}
                </div>
              </div>
            </div>
            <InvoiceListToolbar
              cancelSearch={this.onCancelSearch}
              getPackList={this.getPackListData}
              getPickList={this.getPickListData}
              getWarehouseList={this.getWarehouseListData}
              reload={this.onSelectSlot}
              search={this.onSearchText}
              searchText={searchText}
              setStateForGroupedList={() => this.onFilterChange(FILTER.GROUPED_LIST)}
              setStateForHarvest={() => this.onFilterChange(FILTER.HARVEST)}
              setStateForPickPack={isPack => this.onFilterChange(FILTER.PICK_PACK, isPack)}
              setStateForWarehouse={() => this.onFilterChange(FILTER.WAREHOUSE)}
              setStateForInvoices={() => this.onFilterChange(FILTER.SALES_INVOICES)}
              setStateForLabels={() => this.onFilterChange(FILTER.LABELS)}
              showHarvest={isFarmer}
              showGroupedList={isDistributor && currentOrders.length > 0}
              showPickPack={!isRestaurant && currentOrders.length > 0}
              showWarehouseList={warehouseList && warehouseList.length > 0}
              showLabels={isFarmer && currentOrders.length > 0}
              sortByCustomer={this.onSortByCustomer}
              sortByOrder={this.onSortByOrder}
              sortDirection={sortDirection}
              sortMethod={sortMethod}
              dailySalesPurchases={dailySalesPurchases}
            />
          </div>
          <div className="calendar-main">
            <IconButton
              className="calendar-reload"
              onClick={this.onRefreshCalendar}
              style={{
                paddingLeft: isMobile ? 0 : 'auto',
              }}
            >
              <Refresh />
            </IconButton>
            <Paper loading={ordersRequesting}>
              {
                queryDeliveryDate &&
                  <BigCalendar
                    components={{
                      dateCellWrapper: ({ children, value }) => ({
                        ...children,
                        props: {
                          ...children.props,
                          className: `${children.props.className} ${toISO(value) === toISO(deliveryDate) ? 'selected' : ''}`,
                        },
                      }),
                      toolbar: CalendarToolbar,
                    }}
                    defaultDate={new Date(deliveryDate)}
                    defaultView="month"
                    eventPropGetter={this.eventStyleGetter}
                    events={events}
                    longPressThreshold={50}
                    onNavigate={this.onNavigate}
                    onSelectSlot={this.onSelectSlot}
                    selectable
                    step={60}
                    views={allViews}
                    localizer={localizer}
                    formats={isMobile ? formats : null}
                  />
              }
              {
                !queryDeliveryDate &&
                  <BigCalendar
                    components={{
                      dateCellWrapper: ({ children, value }) => ({
                        ...children,
                        props: {
                          ...children.props,
                          className: `${children.props.className} ${toISO(value) === toISO(deliveryDate) ? 'selected' : ''}`,
                        },
                      }),
                      toolbar: CalendarToolbar,
                    }}
                    defaultView="month"
                    eventPropGetter={this.eventStyleGetter}
                    events={events}
                    longPressThreshold={50}
                    onNavigate={this.onNavigate}
                    onSelectSlot={this.onSelectSlot}
                    selectable
                    step={60}
                    views={allViews}
                    localizer={localizer}
                    formats={isMobile ? formats : null}
                  />
              }
            </Paper>
          </div>
        </div>
        <Paper indicator noPadding>
          {
            currentOrders.map((order, index) => (
              <InvoiceCard
                expanded={expanded === order.id}
                formatMessage={formatMessage}
                index={index}
                key={order.id}
                order={order}
                orderRequesting={
                  orderRequesting &&
                  this.state.orderRequesting &&
                  requestingId === order.id
                }
                readOrder={(id, ...args) => {
                  this.setState({ requestingId: id });
                  readOrder(id, ...args);
                }}
                searchText={searchText}
                setExpanded={(expanded, callback) =>
                  this.setState({
                    expanded,
                  }, callback())}
                updateOrder={(id, payload) => {
                  this.setState({ requestingId: id });
                  updateOrder(
                    id,
                    {
                      ...payload,
                      onSuccess: (data) => {
                        if (data.relatedOrderIds) {
                          data.relatedOrderIds.forEach(
                            (relatedOrderId) => {
                              readOrder(
                                relatedOrderId,
                                { isTrack: true },
                              );
                              this.onOrderUpdated(relatedOrderId);
                            },
                          );
                        }
                      },
                    },
                  );
                }}
                onUpdate={this.onOrderUpdated}
              />
            ))
          }
        </Paper>
        <ScrollToTop invisibleHeight={400} />
        <SyncComponent
          uniqueKey="calendar"
          channels={currentOrders.map(({ id }) => id)}
          onGetMessage={this.onGetOrderMessage}
          messageHandler={(sendMessage) => { this.sendMessage = sendMessage; }}
        />
        <PrintPreviewDialog
          onClose={this.onPrintClose}
          open={printDlgOpen}
          title={`${formatMessage('Print Preview')} - ${printDlgTitle !== '' ? formatMessage(printDlgTitle) : ''}`}
          type={filter}
          currentSize={currentSize}
          handlePrintSizeChange = {this.handlePrintSizeChange}
        >
          <DropDownPrint
            deliveryDate={deliveryDate}
            info={filterData}
            pickpackRequesting={pickListRequesting && packListRequesting}
            requesting={this.props[`${printRequesting}Requesting`]}
            type={filter}
            isPack={isPack}
            isPick={isPick}
            orders={currentOrders}
            printHeaderChecked={printHeaderChecked}
            checkUpdated={this.updateCheckState}
            currentSize={currentSize}          
          />
        </PrintPreviewDialog>
        <Dialog
          open={placedOrderDialogOpen}
          onClose={this.handlePlacedOrderDialogClose}
          >
          <DialogTitle></DialogTitle>
          <DialogContent>
            <DialogContentText style={{ color: '#151b1e' }}>
              <div>
                <div style={{ marginBottom: '20px', fontSize: '20px' }}>
                  {formatMessage('Thank you, your order has been placed.')}
                </div>
                <Container>
                  <Row>
                    <Col>{formatMessage('Order Numer:')}</Col>
                    <Col>{`#${expandedOrder.orderNum}`}</Col>
                  </Row>
                  <Row>
                    <Col>{formatMessage('Order Totals:')}</Col>
                    <Col>{`$${expandedOrder.totalPrice}`}</Col>
                  </Row>
                  <Row>
                    <Col>{formatMessage('Seller:')}</Col>
                    <Col>{expandedOrder.seller && expandedOrder.seller.account && expandedOrder.seller.account.profile && expandedOrder.seller.account.profile.companyName}</Col>
                  </Row>
                </Container>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handlePlacedOrderDialogClose} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('orders', 'order')(state, 'order'),
  ...selectState('orders', 'orders')(state, 'orders'),
  ...selectState('orders', 'packList')(state, 'packList'),
  ...selectState('orders', 'pickList')(state, 'pickList'),
  ...selectState('orders', 'warehouseList')(state, 'warehouseList'),
  ...selectState('orders', 'dailySalesPurchases')(state, 'dailySalesPurchases'),
});

export default compose(
  setDisplayName('Calendar'),
  connect(
    mapStateToProps,
    dispatch => ({
      ...dispatchRestMaker([
        [ordersActions, 'order'],
      ])(dispatch),
      getPackList: payload => dispatch(getPackList(payload)),
      getPickList: payload => dispatch(getPickList(payload)),
      getWarehouseList: payload => dispatch(getWarehouseList(payload)),
      getDailySalesPurchases: payload => dispatch(getDailySalesPurchases(payload)),
    }),
  ),
  withStyles(styles),
  immutableToJS,
  injectIntl,
)(Calendar);
